import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Plus } from 'lucide-react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { useCreateRecordMutation } from '../api/use-records-query'
import { useAuthStore } from '@/features/auth/stores/use-auth-store'

interface CreateRecordModalProps {
  projectId: string
  open: boolean
  onClose: () => void
  /** When provided, called instead of navigating to the record page */
  onCreated?: (recordId: string) => void
}

export function CreateRecordModal({ projectId, open, onClose, onCreated }: CreateRecordModalProps) {
  const navigate = useNavigate()
  const user = useAuthStore((s) => s.user)
  const mutation = useCreateRecordMutation(projectId)
  const [error, setError] = useState<string | null>(null)

  const handleCreate = async () => {
    if (!user) return
    setError(null)
    try {
      const result = await mutation.mutateAsync(user.id)
      onClose()
      if (onCreated) {
        onCreated(result.id)
      } else {
        navigate(`/projects/${projectId}/records/${result.id}`)
      }
    } catch (e) {
      setError((e as Error).message)
    }
  }

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>ثبت سابقه جدید</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">
          یک سابقه پزشکی جدید برای این پروژه ایجاد می‌شود. شناسه سابقه به صورت خودکار تولید می‌گردد.
        </p>
        {error && (
          <p className="text-sm text-destructive">{error}</p>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>انصراف</Button>
          <Button onClick={handleCreate} disabled={mutation.isPending} className="gap-2">
            <Plus className="w-4 h-4" />
            {mutation.isPending ? 'در حال ایجاد...' : 'ایجاد سابقه'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
